<template>
    <div>
        <el-card>
    <el-table :data="tableData" ref="historyTable" size=mini highlight-current-row v-loading="loading" :header-cell-style = "{background:'#987AFF'}" :height='isMobile ? 400 : 600' element-loading-text="拼命加载中">
    <el-table-column v-if="!isMobile" type="index" />
    <el-table-column property="meter_id" :label="$t('QueryDailyUsage.水表编号')"  />
    <el-table-column property="settlement_time" :label="$t('QueryDailyUsage.统计日期')"  />
    <el-table-column property="flow" :label="$t('QueryDailyUsage.当日用量')" />
    <el-table-column property="total_flow" :label="$t('QueryDailyUsage.当前表码数')" />
    <el-table-column property="finished" :label="$t('QueryDailyUsage.是否结算')" >
      <template slot-scope="scope">
        <span v-if="scope.row.finished === true || scope.row.finished === 'true' || scope.row.finished === 0">{{ $t('QueryDailyUsage.是') }}</span>
        <span v-else>{{ $t('QueryDailyUsage.否') }}</span>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="TableDailyUsageparameter.pagenum"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="TableDailyUsageparameter.pagesize"
      :small="isMobile"
      :pager-count="isMobile ? 5 : 7"
      :layout="isMobile ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
      :total="total">
    </el-pagination>
      </el-card>
    </div>
</template>

<script>
export default {
  data () {
    return {
    // 手机端
      isMobile: false,
    // table数据
      tableData: [{
        meterId: null,
        sumFlow: null,
        unit: null,
        insertTime: null,
        valveStatus: null
      }],
      // tab数据加载转圈
      loading: false,
      total: 0,
      // 查询日用水参数
      TableDailyUsageparameter: {
        token: null,
        meter_id: null,
        pagenum: 1,
        pagesize: 20,
        start_date: null,
        end_date: null
      }
    }
  },
  created () {
    this.updateIsMobile()
    this.TableDailyUsageparameter.token = this.$store.state.print.goodsForeNo.token
    console.log(this.$parent.meterMaid, '获取父组件的表号')
    this.TableDailyUsageparameter.meter_id = this.$parent.meterMaid
    this.metnData()
    this.resetScrollPosition()
  },
  mounted () {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateIsMobile)
  },
  methods: {
    updateIsMobile () {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    },
    // 封装滚动条重置逻辑
    resetScrollPosition (direction = 'both') {
      this.$nextTick(() => {
        const tableRef = this.$refs.historyTable
        if (!tableRef?.$el) return

        const scrollBody = tableRef.$el.querySelector('.el-table__body-wrapper')
        if (!scrollBody) return

        // 现代浏览器推荐使用 scrollTo
        switch (direction) {
          case 'vertical':
            scrollBody.scrollTo({ top: 0, behavior: 'auto' })
            break
          case 'horizontal':
            scrollBody.scrollTo({ left: 0, behavior: 'auto' })
            break
          default: // both
            scrollBody.scrollTo({ top: 0, left: 0, behavior: 'auto' })
        }

        // 兼容写法（Vue2旧项目可能需要）
        // if (direction === 'vertical' || direction === 'both') {
        //   scrollBody.scrollTop = 0
        // }
        // if (direction === 'horizontal' || direction === 'both') {
        //   scrollBody.scrollLeft = 0
        // }
      })
    },
    metnData () {
      this.$api.waterMeter.meterFlowUse(this.TableDailyUsageparameter).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '设备日用水')
          this.tableData = res.data.data
          this.total = res.data.total
          this.resetScrollPosition()
        }
      })
    },
    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
      console.log(newSize, 'q')
      this.TableDailyUsageparameter.pagesize = newSize
      this.metnData()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange (newPage) {
      console.log(newPage)
      this.TableDailyUsageparameter.pagenum = newPage
      this.metnData()
    }
  }
}
</script>

<style lang="less" scoped>
.el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
        }
@media (max-width: 768px) {
  ::v-deep .el-pagination{
    display: flex;
    justify-content: center;
    margin: 10px 0 4px;
  }
}
</style>
